<template>
  <transition name="fade">
    <div class="modal show" style="display: block;">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <span></span>
            Create a New Sign Up Form
            <div class="btn-close-wrapper" @click.stop="closeModal">
              <span class="material-icons">close</span>
            </div>
          </div>
          <div class="modal-body">
            <form @submit.prevent>
              <div class="form-group">
                <label>Name</label>
                <input type="text" v-model.trim="name" class="form-control" placeholder="Name" />
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <span></span>
            <button type="button" class="xpl-button xpl-button--primary" @click.prevent="createForm" :disabled="!name">Create</button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
  import EventBus from '@/event-bus';
  import * as api from '@/api';

  export default {
    data() {
      return {
        name: '',
      };
    },
    methods: {
      closeModal() {
        EventBus.$emit('create_form.close');
      },
      createForm(event) {
        const target = event.target || event.srcElement;

        target.disabled = true;

        const payload = {
          name: this.name,
          legacy: true,
        };

        api.createForm(payload).then((response) => {
          this.$toasted.success(response.message);
          this.closeModal();
          this.$router.push(`/contacts/embed/${response.form.uuid}`);
        }).catch((err) => {
          this.$toasted.error(err.message);
          target.disabled = false;
        });
      },
    },
  };
</script>
